module.exports = __webpack_public_path__ + "static/media/woman-drink.b5e7c69e.jpg";